<div class="container-fluid creator-updator-box">
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-list dense class="left-aligned-mat-list">
        <mat-list-item *ngIf="data && data.createdAt">
          <strong class="pr-2">{{ 'common.words.createdAt' | translate }}:</strong>
          {{ data.createdAt | date:'dd LLL yyyy HH:mm' }}
        </mat-list-item>
        <mat-list-item *ngIf="data && data.createdBy && showUserSection">
          <strong class="pr-2">{{ 'common.words.createdBy' | translate }}:</strong>
          <a routerLink="/{{ lang }}/app/users/detail/{{ data.createdBy._id }}">{{ data.createdBy.firstName }}
            {{ data.createdBy.lastName }}</a>
        </mat-list-item>
      </mat-list>
    </div> <!-- /.col -->
    <div class="col-12 col-md-6">
      <mat-list dense class="left-aligned-mat-list">
        <mat-list-item *ngIf="data && data.updatedAt">
          <strong class="pr-2">{{ 'common.words.updatedAt' | translate }}:</strong>
          {{ data.updatedAt | date:'dd LLL yyyy HH:mm' }}
        </mat-list-item>
        <mat-list-item *ngIf="data && data.updatedBy && showUserSection">
          <strong class="pr-2">{{ 'common.words.updatedBy' | translate }}:</strong>
          <a routerLink="/{{ lang }}/app/users/detail/{{ data.updatedBy._id }}">{{ data.updatedBy.firstName }}
            {{ data.updatedBy.lastName }}</a>
        </mat-list-item>
      </mat-list>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-list dense class="left-aligned-mat-list">
        <mat-list-item *ngIf="data && data.cancellationRequestDate">
          <strong class="pr-2" *ngIf="data.cancellation">{{ 'common.words.cancellationRequestDate' | translate }}:</strong>
          <strong class="pr-2" *ngIf="!data.cancellation">{{ 'common.words.deactivateRequestDate' | translate }}:</strong>
          {{ data.cancellationRequestDate | date:'dd LLL yyyy HH:mm' }}
        </mat-list-item>
        <mat-list-item *ngIf="data && data.cancellationRequestBy">
          <strong class="pr-2" *ngIf="data.cancellation">{{ 'common.words.cancellationRequestBy' | translate }}:</strong>
          <strong class="pr-2" *ngIf="!data.cancellation">{{ 'common.words.deactivateRequestBy' | translate }}:</strong>
          <a routerLink="/{{ lang }}/app/users/detail/{{ data.cancellationRequestBy._id }}">{{ data.cancellationRequestBy.firstName }}
            {{ data.cancellationRequestBy.lastName }}</a>
        </mat-list-item>
      </mat-list>
    </div> <!-- /.col -->
  </div>
</div> <!-- /.container -->
